import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent as _logEvent, setUserProperties } from 'firebase/analytics';
import { __APP_VERSION__ } from '@local-utils/const';
import { getChannel } from '@local-utils/common';

const firebaseConfig = {
  apiKey: 'AIzaSyChQtvPiMIxkoqYwwMAQUKxxtGxLg3-tYY',
  authDomain: 'honyup.firebaseapp.com',
  projectId: 'honyup',
  storageBucket: 'honyup.firebasestorage.app',
  messagingSenderId: '446628454554',
  appId: '1:446628454554:web:40fc12dfb6f919eb84ff23',
  measurementId: 'G-TMX4KSWM1F',
};

const app = initializeApp(firebaseConfig);

// 安全地初始化 Analytics，添加错误处理
let analytics = null;

try {
  // 只在浏览器环境中初始化
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
    setUserProperties(analytics, {
      version: __APP_VERSION__,
    });
  }
} catch (error) {
  // 静默处理错误，不影响应用运行
  // Firebase 会自动使用本地配置的 measurementId 作为后备
  console.warn('Firebase Analytics 初始化警告（不影响使用）:', error.message);
}

export { analytics };

const channel = getChannel();

/**
 * firebase埋点上报方法
 * https://firebase.google.cn/docs/reference/js/analytics?hl=zh-cn#logevent
 * @param eventName {string} 事件ID
 * @param [eventParams] {{[key: string]: any}} 事件参数
 * @param [options] {{global: boolean}} 可选参数，一般用不着
 */
export function logEvent(eventName, eventParams, options) {
  try {
    if (analytics) {
      _logEvent(
        analytics,
        eventName,
        {
          ...eventParams,
          channel: channel,
        },
        options,
      );
    }
  } catch (error) {
    // 静默处理错误，不影响应用运行
    console.warn('Firebase 埋点上报失败:', error.message);
  }
}
